import { babyface } from '../../../lib/image/CDNUrl';

const EVENT_BANNER_URI = `${babyface}/event/event_banner`;
const EVENT_DETAIL_URI = `${babyface}/event_detail`;
const HOME_BANNER_URI = `${babyface}/home/home_banner`;

export const EVENT_BANNER_MARKETINGAGREE = {
  src: `${EVENT_BANNER_URI}_marketing-agree.jpg`,
  alt: `마케팅 수신 동의 이벤트 배너`,
};

export const EVENT_DETAIL_MARKETINGAGREE = {
  src: `${EVENT_DETAIL_URI}/marketing-agree.jpg`,
  alt: `마케팅 수신 동의 이벤트 안내사항`,
};

export const EVENT_DETAIL_MARKETINGAGREE_BUTTONS = [
  {
    src: `${EVENT_DETAIL_URI}/marketing-agree_button_01.jpg`,
    alt: '마케팅 수신 동의하기 버튼',
  },
];

export const HOME_BANNER_MARKETINGAGREE = {
  src: `${HOME_BANNER_URI}_marketing-agree.jpg`,
  alt: `마케팅 수신 동의하기 이벤트 홈배너`,
};

export const SIGNUP_MARKETINGAGREE = {
  src: `${babyface}/event/event-signup-marketing-agree.png`,
  alt: '마케팅 수신동의 1천원 할인',
};
